module.exports = __webpack_public_path__ + "img/f63.743e8df5.png";